import React, { useEffect } from 'react'
import classNames from 'classnames'
import { MdClose } from 'react-icons/md'
import { Transition } from '@headlessui/react'
import styles from '@/styles/components/Toast.module.scss'

const Toast = ({ variant = '', message = '', handleClick }) => {
  useEffect(() => {
    setTimeout(() => {
      handleClick()
    }, 5000)
  }, [])

  const color = () => {
    switch (variant) {
      case 'Success':
        return styles.success
      case 'Danger':
        return styles.danger
      case 'Remove':
        return styles.danger
      case 'Info':
        return styles.info
      case 'Warning':
        return styles.warning
      case 'Alert':
        return styles.warning
      default:
        return
    }
  }

  return (
    <Transition
      show={true}
      enter="transition duration-100 ease-out"
      enterFrom="transform scale-95 opacity-0"
      enterTo="transform scale-100 opacity-100"
      leave="transition duration-75 ease-out"
      leaveFrom="transform scale-100 opacity-100"
      leaveTo="transform scale-95 opacity-0"
    >
      <div
        className={classNames(
          'right-0 h-10 w-80 bg-custom-gray-50 flex items-center justify-between rounded-sm border-l-4',
          styles.toastAnimation,
          color()
        )}
        aria-live="assertive"
        role="alert"
        aria-atomic="true"
      >
        <p className="pl-4 text-xs animated">{message}</p>
        <MdClose
          className="h-4 w-4 text-white cursor-pointer mr-4"
          onClick={() => {
            handleClick()
          }}
        />
      </div>
    </Transition>
  )
}

export default Toast
